import styled from 'styled-components'
import Browser from '../../../services/Browser'
import { breakpoints } from '../../../constants'

export const StyledCardFields = styled.div`
	margin-top: 4rem;
	margin-bottom: ${Browser.isIE() ? '0rem' : '4rem'};
	display: ${Browser.isIE() ? 'flex' : 'grid'};
	flex-direction: column;
	grid-template-columns: repeat(3, 1fr);
	align-items: ${Browser.isIE() ? 'auto' : 'end'};
	grid-gap: 4rem 15px;

	.installments,
	.recurrent-pay-day,
	.cardNumber,
	.cardPrintedName,
	.card-month-validity,
	.card-year-validity,
	.security-code,
	.savecard-container {
		grid-column: 1 / -1;
	}

	.card-month-validity,
	.card-year-validity,
	.security-code,
	.savecard-container {
		@media screen and (min-width: ${breakpoints.MOBILE}px) {
			grid-column: auto;
		}
	}

	& > * {
		${Browser.isIE() ? `margin-bottom: 4rem` : null};
	}

	.savecard-container {
		display: flex;
		flex-direction: row-reverse;
		width: max-content;
		justify-content: space-between;
		align-items: center;
	}

	#select-savecard {
		margin-right: 10px;
	}

	@media screen and (max-width: ${breakpoints.MOBILE}px) {
		.savecard-container {
			width: 80%;
		}
	}

	@media screen and (max-width: ${breakpoints.IPHONE_SE}px) {
		.savecard-container {
			width: 95%;
		}
	}
`
